// import { faPlus } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ColumnDef } from '@tanstack/react-table';
//import PageBreadcrumb from 'components/common/PageBreadcrumb';
//import ProjectsTopSection from 'components/modules/project-management/ProjectsTopSection';
import TemplatesTopSection from 'components/modules/project-management/TemplatesTopSection';
import TemplateViewItem from 'components/modules/project-management/board-view/TemplateViewItem';
//import { defaultBreadcrumbItems } from 'data/commonData';
import { PitchDeck } from 'data/pitchdecks';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import interceptor from 'services/interceptor';
import projectsService from 'services/project';
//import ProjectStatusService from 'services/projectstatus';
import { Project } from 'data/projects';
import pitchDeckService from 'services/pitchdeck';
import { useNavigate } from 'react-router-dom';
//import { pitchDeckStatusList } from 'data/pitchdeckstatus';
import pitchDeckStatusService from 'services/pitchdeckstatus';
import { Budget } from 'data/budgets';

export const columns: ColumnDef<PitchDeck>[] = [
  {
    // For filtering and searching projects by status
    id: 'status',
    accessorFn: ({ status }) => {
      return {
        label: status || '',
        displayType: status || ''
        // caninclude stuff like free/paid later
      };
    }
  },
  {
    // For searching projects by name
    accessorKey: 'name'
  }
];
const TemplateBoardView = () => {
  const navigate = useNavigate();
  const [pitchdecks, setPitchDecks] = useState([]);

  useEffect(() => {
    interceptor.apiWithAuth
      .get(`/pitchdeck/get-all-templates`)
      .then(response => {
        setPitchDecks(response.data);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  const handleCreateButtonClick = async () => {
    // Create a blank starter project and navigate to the create pitchdeck page
    // then we can update the project with the pitchdeck and data that belongs to it
    const generateGuid = (): string => {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
          const r = (Math.random() * 16) | 0,
            v = c === 'x' ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    };
    let initStatus;
    try {
      const response = await interceptor.apiWithAuth.get(
        '/projectStatus/get-all'
      );
      if (response && response.data && response.data.length > 0) {
        const status = response.data.find(
          (status: { label: string }) => status.label === 'New'
        );
        if (status) {
          console.log('Status found:', status);
          initStatus = status;
        } else {
          console.log('Status with label "New" not found.');
        }
      } else {
        console.log('No data received from the API.');
      }
    } catch (error) {
      console.error('API Error:', error);
    }

    const project: Project = {
      title: 'Empty Project',
      userId: localStorage.getItem('userId') || '',
      createdBy: localStorage.getItem('userId') || '',
      statusId: initStatus?.statusId || '',
      status: initStatus
    };

    const emptyBudget: Budget = {
      amount: 1000000,
      currency: 'USD',
      type: 'Post-Production Only',
      notes: '',
      status: 'Awaiting Approval',
      isActive: true
    };

    project.budget = emptyBudget;

    const draftStatus =
      await pitchDeckStatusService.getPitchDeckStatusByName('Draft');

    const pitchDeck: PitchDeck = {
      pitchDeckId: generateGuid(),
      //projectId: project.projectId,
      generatedByAI: false,
      title: 'Empty PitchDeck',
      type: 'film',
      contentOuterHtml: '',
      publishedURN: '',
      trackingEnabled: true,
      thumbnail:
        'https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/nupitch_f7533443-7bcc-419d-abc4-3b17a1169a92_101_bg_img.jpg',
      isTemplate: false,
      statusId: draftStatus.statusId,
      status: draftStatus,
      createdBy: localStorage.getItem('userId') || ''
    };

    pitchDeckService.addPitchDeck(pitchDeck).then(data1 => {
      if (data1) {
        console.log('pitchdeck ID:', data1);
        project.pitchDecks = [data1];
      } else {
        console.error('Error:', 'problem with returned pitchdeck ID');
      }
    });

    projectsService.addProject(project).then(data => {
      if (data && data.length > 0) {
        navigate(`/pages/slide-editor/${data}/${pitchDeck.pitchDeckId}`);
      } else {
        console.error('Error:', 'problem with returned project ID');
      }
    });
  };

  const table = useAdvanceTable<PitchDeck>({
    data: pitchdecks,
    columns,
    pageSize: 10,
    pagination: true,
    sortable: true
  });

  return (
    <div>
      {/* <PageBreadcrumb items={defaultBreadcrumbItems} /> */}
      <AdvanceTableProvider {...table}>
        <div className="d-flex flex-wrap mb-4 gap-3 gap-sm-6 align-items-center">
          <h2 className="mb-0">
            <span className="me-3">Templates</span>{' '}
            <span className="fw-normal text-700">({pitchdecks.length})</span>
          </h2>
          <Button
            className=""
            variant="phoenix-warning"
            onClick={() => handleCreateButtonClick()}
          >
            Create my own!
          </Button>
        </div>

        <TemplatesTopSection />
        <Row className="g-3 mb-9">
          {table
            .getRowModel()
            .rows.map(row => row.original)
            .map(pitchdeck => (
              <Col xs={12} sm={6} md={4} xxl={3} key={pitchdeck.pitchDeckId}>
                <TemplateViewItem pitchdeck={pitchdeck} />
              </Col>
            ))}
        </Row>
      </AdvanceTableProvider>
    </div>
  );
};

export default TemplateBoardView;
